// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");

function SecondaryLayout(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "bg-white grow flex flex-col items-stretch"
  });
}

let make = SecondaryLayout;

exports.make = make;
/* react/jsx-runtime Not a pure module */
